import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-invoice-data-tips',
  templateUrl: './invoice-data-tips.component.html',
  styleUrls: ['./invoice-data-tips.component.scss'],
})
export class InvoiceDataTipsComponent {
  @Input() isDataTipsVisible = false;
  @Output() closeDataTips = new EventEmitter<any>();

  closeTips() {
    this.closeDataTips.emit();
  }
}
